const EmptyState = ({ icon, title, description }) => {
  return (
    <div className="flex flex-col gap-2 items-center max-w-sm">
      {Boolean(icon) && icon}

      {title && (
        <p className="m-0 p-0 text-xl font-semibold leading-loose text-gray-900">
          {title}
        </p>
      )}

      {description && (
        <p className="m-0 p-0 text-center text-sm leading-tight text-gray-600">
          {description}
        </p>
      )}
    </div>
  );
};

export default EmptyState;
